import React from "react";

import { formatDateVisitsDates } from "../utils/helperFn";

function VerificationIcons({ type, _verificationData, dates, visits }) {
  // const iconClass = verificationData !== null ? "ic-verified" : "ic-unverified";

  // const renderAvatar = () => {
  //   if (verificationData === null) {
  //     return <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img me-lg-1" />;
  //   }

  //   if (verificationData && verificationData?.profile === "") {
  //     return <span className="ic ic-avatar-grey ic-19 has-avatar-icon has-cover-img me-lg-1" />;
  //   }

  //   if (verificationData?.profile) {
  //     return (
  //       <img
  //         src={`https://simplefirm-bucket.s3.amazonaws.com/static/${verificationData?.profile}`}
  //         alt=""
  //         className="verify-profile-img"
  //       />
  //     );
  //   }

  //   return <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img me-lg-1" />;
  // };

  const getLabelAndValue = () => {
    switch (type) {
      case "first":
        return {
          label: "",
          value: formatDateVisitsDates(dates?.[0]?.date),
          id: "treatment_first_date92",
        };
      case "last":
        return {
          label: "",
          value: formatDateVisitsDates(dates?.[1]?.date),
          id: "treatment_second_date92",
        };
      case "visits":
        return {
          label: "Visits:",
          value:
            visits === null ||
            visits === undefined ||
            visits === "" ||
            !Number.isFinite(Number(visits))
              ? "-"
              : visits,
          id: "treatment_visits92",
        };
      default:
        return { label: "", value: "", id: "" };
    }
  };

  const { label, value, id } = getLabelAndValue();
  const isPlaceholder = value === "-" || value === "--/--/--";

  return (
    <>
      {/* {renderAvatar()} */}
      {label && (
        <span className="label text-primary-25" style={{ fontWeight: "600" }}>
          {label}
        </span>
      )}
      <span
        className={isPlaceholder ? "text-primary-25" : "text-black"}
        style={{ fontWeight: "600" }}
        id={id}
      >
        {value}
      </span>
      {/* <i className={`ic ${iconClass} ic-19`} /> */}
    </>
  );
}

export default React.memo(VerificationIcons);
